<template>
  <div class="register">
  </div>
</template>

<script>
export default {
    data() {
      return {
        name:'222'
      }
    },
    methods: {
      
    }
}
</script>

<style lang="less" scoped>

</style>>

